import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Table } from 'react-bootstrap';
import { Button, Icon, Money } from 'modules';
import FormInputWrapper from 'modules/FormInputWrapper';
import ButtonAdd from './components/ButtonAdd';
import { selectClientAccess } from 'stores/onlineForm/onlineForm';
import { DebtData } from './components/DebtModal';
import './style.scss';
import ButtonEdit from './components/ButtonEdit';

interface DebtListProps {
  name: string;
  list?: any[];
  readOnly?: boolean;
  required?: boolean;
  error?: string;
  onChange: (e: any) => void;
}

const DebtList = ({ name, list, readOnly, required, error, onChange }: DebtListProps) => {
  const isClientAccess = useSelector(selectClientAccess);

  const onSubmit = (data: DebtData) => {
    const newList = (list ? [...list] : []) as GQL.IDebt[];
    newList.push(data as any);
    onChange({
      target: {
        name,
        value: newList,
      },
    });
  };

  const onEditSubmit = (index: number, data: DebtData) => {
    const newList = (list ? [...list] : []).map((d: GQL.IDebt, i: number) => (i === index ? data : d));
    onChange({
      target: {
        name,
        value: newList,
      },
    });
  };

  const onClickDelete = (index: number) => {
    const newList = (list ? [...list] : []).filter((_, i: number) => i !== index);
    onChange({
      target: {
        name,
        value: newList,
      },
    });
  };

  const getSumZbyvaUhradit = () => {
    return list?.reduce((acc: number, d: GQL.IDebt) => {
      acc += d.zbyva_uhradit || 0;
      return acc;
    }, 0);
  };

  return (
    <>
      <Row>
        <Col>
          <FormInputWrapper
            label={`Dlhy${list && list?.length > 0 ? ` (${list?.length})` : ``}`}
            required={required}
            error={error}
          >
            <Table variant="table-hover">
              <thead>
                <tr>
                  <th>Veriteľ</th>
                  <th className="d-none d-sm-table-cell">Stav dlhu</th>
                  <th className="d-none d-sm-table-cell">Druh dlhu</th>
                  <th className="text-right">Zostáva</th>
                  {readOnly !== true && <th style={{ width: '40px' }} />}
                </tr>
              </thead>
              <tbody>
                {list?.map((debt: GQL.IDebt, index: number) => {
                  return (
                    <tr key={index}>
                      <th>
                        {debt.jmeno}
                        {readOnly !== true && (
                          <ButtonEdit debt={debt} onSubmit={(data: DebtData) => onEditSubmit(index, data)} />
                        )}
                      </th>
                      <td className="d-none d-sm-table-cell">{debt.debtStatus?.kod}</td>
                      <td className="d-none d-sm-table-cell">{debt.druh_smlouvy_veritele}</td>
                      <td align="right">
                        <Money value={debt.zbyva_uhradit || 0} />
                      </td>
                      {readOnly !== true && (
                        <td align="center" valign="middle" style={{ padding: 1, paddingTop: 4, maxWidth: '30px' }}>
                          <Button
                            type="button"
                            variant="danger"
                            disabled={isClientAccess}
                            className="btn-input-size"
                            onClick={() => onClickDelete(index)}
                          >
                            <Icon type="times" />
                          </Button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>

              {(list || []).length === 0 && (
                <tfoot>
                  <tr>
                    <td colSpan={5} className="text-center">
                      Zoznam je prázdny
                    </td>
                  </tr>
                </tfoot>
              )}
              {(list || []).length > 0 && (
                <tfoot>
                  <tr>
                    <td />
                    <td className="d-none d-sm-table-cell" />
                    <td className="d-none d-sm-table-cell" />
                    <td align="right">
                      <Money value={getSumZbyvaUhradit()} />
                    </td>
                    {readOnly !== true && <td />}
                  </tr>
                </tfoot>
              )}
            </Table>
          </FormInputWrapper>
        </Col>
      </Row>
      {readOnly !== true && (list || []).length < 10 && (
        <Row>
          <Col className="text-right">
            <ButtonAdd onSubmit={onSubmit} />
          </Col>
        </Row>
      )}
    </>
  );
};

export default DebtList;
